import { TProps } from './types/TProps';

export const LinkContent = ({ text, Icon, iconOffset, active = false }: TProps) => {
  const textColorClass = active ? 'text-title' : 'text-foreground-muted';

  return (
    <span
      className={`relative flex w-[200px] font-medium text-base leading-[18px] capitalize pl-[31px] flex-none ${textColorClass}`}
    >
      <span className="absolute top-1/2 -translate-y-1/2" style={{ left: iconOffset || 0 }} aria-hidden="true">
        <Icon />
      </span>
      {text}
    </span>
  );
};
